import { Text, breakpoints } from "@asurion-core/mx-asurion-ui-react";
import { DetailsContainer } from "@ubif/components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { MagnifyingGlassIcon } from "./Icons";

type CustomerSearchNoResults = {
  searchText: string;
};

const SearchNoResults = ({ searchText }: CustomerSearchNoResults) => {
  const { t } = useTranslation("root-config");
  return (
    <StyledContainer>
      <Text>{t("GlobalSearch.SearchNoResults.CustomersNotFound", { searchText: searchText })}</Text>
      <Text>{t("GlobalSearch.SearchNoResults.CheckSearchEntry")}</Text>
      <Text>{t("or")}</Text>
      <Text>{t("GlobalSearch.SearchNoResults.SearchCustomerEntryIsCorrect")}</Text>
      <Text>
        {t("YouCan")} <Link to="/check-in/arrivals/#add-new">{t("createNewArrival")}</Link> {t("or")}{" "}
        <Link to="/check-in">{t("check-in")}</Link> {t("thisCustomer")}
      </Text>
    </StyledContainer>
  );
};

export const CustomerSearchNoResults = ({ searchText }: CustomerSearchNoResults) => {
  return (
    <StyledContainerWithGap>
      <MagnifyingGlassIcon />
      <SearchNoResults searchText={searchText} />
    </StyledContainerWithGap>
  );
};

const StyledContainer = styled(DetailsContainer)`
  align-items: center;
`;

const StyledContainerWithGap = styled(StyledContainer)`
  gap: var(--gutter-md);
  ${breakpoints.lg} {
    gap: var(--gutter-lg);
  }
`;
